const ageGroups = ['2-5', '5-7', '7-9', '9-11']

export default ageGroups
